import repairApi from "@/api/repairApi";

export enum REPAIR_STATUS {
  REPAIR_STATUS_ACTIVE = 1,
  REPAIR_STATUS_INACTIVE = 0,
}

export enum REPAIR_METHOD {
  REPAIR_METHOD_RESTORE = 1,
  REPAIR_METHOD_RENEW = 2,
}

export const MAPPING_METHOD_NAME = {
  1: "経過日数",
  2: "リセット",
};

export interface IRepair {
  id: string;
  name: string;
  depreciation_method: REPAIR_METHOD;
  status: REPAIR_STATUS;
  order: number;
}
export class RepairDTO implements IRepair {
  id: string;
  name: string;
  depreciation_method: REPAIR_METHOD;
  status: REPAIR_STATUS;
  order: number;
}

export default class Repair extends RepairDTO {
  constructor(dto?: RepairDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: "",
      status: REPAIR_STATUS.REPAIR_STATUS_ACTIVE,
      depreciation_method: REPAIR_METHOD.REPAIR_METHOD_RESTORE,
    });
  }

  public save() {
    if (this.id) {
      return repairApi.update(this);
    } else {
      return repairApi.create(this);
    }
  }

  get statusName() {
    return this.status === REPAIR_STATUS.REPAIR_STATUS_ACTIVE ? "on" : "off";
  }

  get methodName() {
    return MAPPING_METHOD_NAME[this.depreciation_method] ?? "-";
  }
}
